import { inject, injectable } from 'tsyringe';
import { type ICompanyUserTokenRepository } from 'application/repositorySchemas/ICompanyUserTokenRepository';
import { type ICompanyProfilePublishRepository } from 'application/repositorySchemas/ICompanyProfilePublishRepository';
import { type ICompanyProfilePublishClient } from 'interfaceAdapter/gatewaySchemas/ICompanyProfilePublishClient';

@injectable()
export class CompanyProfilePublishRepository implements ICompanyProfilePublishRepository {
    constructor(
        @inject('ICompanyUserTokenRepository')
        public readonly companyUserToken: ICompanyUserTokenRepository,
        @inject('ICompanyProfilePublishClient')
        public readonly companyProfilePublishClient: ICompanyProfilePublishClient,
    ) {}

    // TODO 型づけをサボっている
    public async post(company: any) {
        const { data, message } = await this.companyProfilePublishClient.post({
            token: this.companyUserToken.get() || '',
            company,
        });

        if (message) {
            throw new Error(message);
        }

        return data;
    }
}
